/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    FareTypes,
    FareTypesFromJSON,
    FareTypesFromJSONTyped,
    FareTypesToJSON,
} from './';

/**
 * 
 * @export
 * @interface FareTypesCriteriaRequest
 */
export interface FareTypesCriteriaRequest {
    /**
     * 
     * @type {FareTypes}
     * @memberof FareTypesCriteriaRequest
     */
    value?: FareTypes;
    /**
     * 
     * @type {boolean}
     * @memberof FareTypesCriteriaRequest
     */
    exclude?: boolean;
}

export function FareTypesCriteriaRequestFromJSON(json: any): FareTypesCriteriaRequest {
    return FareTypesCriteriaRequestFromJSONTyped(json, false);
}

export function FareTypesCriteriaRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FareTypesCriteriaRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': !exists(json, 'value') ? undefined : FareTypesFromJSON(json['value']),
        'exclude': !exists(json, 'exclude') ? undefined : json['exclude'],
    };
}

export function FareTypesCriteriaRequestToJSON(value?: FareTypesCriteriaRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'value': FareTypesToJSON(value.value),
        'exclude': value.exclude,
    };
}


